/* eslint-disable */

export default {
  isEmpty(str) {
    return (str !== 0 && !str || /^\s*$/.test(str));
  },

  isBadText(str) {
    return (str.includes('"') || str.includes("'"));
  },

  isEmail(str) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(str);
  },

  isDate(str) {
    const re = /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/;
    return re.test(str) && (new Date(str).getFullYear() <= 2015);
  },

  isPasswordLength(str) {
    const re = new RegExp('^(?=.{6,})');
    return re.test(str);
  },

  hasLowercase(str) {
    const re = new RegExp('^(?=.*[a-z])');
    return re.test(str);
  },
  hasUppercase(str) {
    const re = new RegExp('^(?=.*[A-Z])');
    return re.test(str);
  },
  hasNumber(str) {
    const re = new RegExp('^(?=.*[0-9])');
    return re.test(str);
  },
  containSpecialSymbols(str) {
    const re = new RegExp('^(?=.*[!@#\$%\^&\*])');
    return re.test(str);
  },
  isPasswordStrong(str) {
    return this.hasLowercase(str) && this.hasUppercase(str) && this.hasNumber(str) && !this.containSpecialSymbols(str) && this.isPasswordLength(str);
  },
  isPasswordMiddle(str) {
    return (this.hasLowercase(str) && this.hasNumber(str) || this.hasNumber(str) && this.hasUppercase(str) || this.hasLowercase(str) && this.hasUppercase(str)) && !this.containSpecialSymbols(str) && this.isPasswordLength(str);
  },
  isPasswordWeak(str) {
    return this.containSpecialSymbols(str);
  },
  arePasswordsSame(password, repassword) {
    return password === repassword;
  },
  isPhone(str) {
    const re = new RegExp('^(\\s*)?(\\+)?([- _():=+]?\\d[- _():=+]?){10,14}(\\s*)?$');
    return re.test(str);
  },

  isNumber(str) {
    const re = new RegExp('^\\d+$');
    return re.test(str);
  },
};



// WEBPACK FOOTER //
// ./scripts/blocks/form/validator/utils/helper.js